import OpenAI from "openai"
import { isBrowser } from "@/lib/agents/isbrowser"
import { excelExtractPropmpt } from './prompts'
import { extractLocaleAndText, uploadFile } from "./utils"


export async function extractExcel(file: File, apiKey: string): Promise<ExtractedDocument> {

  const client = new OpenAI({ apiKey, dangerouslyAllowBrowser: true, baseURL: isBrowser ? "https://signpost-ia-app-qa.azurewebsites.net/decorsify/https://api.openai.com/v1" : undefined })

  const fileu = await uploadFile(file, client, 'user_data')

  console.log("Calling OpenAI...")
  const response = await client.responses.create({
    model: "gpt-5-nano",
    input: [
      {
        role: "user",
        content: [
          {
            type: "input_file",
            file_id: fileu.id,
          },
          {
            type: "input_text",
            text: excelExtractPropmpt,
          },
        ],
      },
    ],
  })

  console.log("Received response from OpenAI.")

  await client.files.delete(fileu.id)

  const responseText = extractLocaleAndText(response.output_text || '')

  // Chunk the table
  const chunks = chunkMarkdownTable(responseText.text, 1024)

  return {
    text: responseText.text,
    chunks,
    locale: responseText.locale
  } as ExtractedDocument

}

function chunkMarkdownTable(table: string, maxChunkSize: number): string[] {
  if (!table) return []
  if (table.length <= maxChunkSize) return []
  const lines = table.split('\n')
  const chunks: string[] = []
  let currentChunk: string[] = []
  let currentSize = 0

  // Try to keep the header with each chunk
  const header = lines.slice(0, 2) // First two lines are typically header + separator
  const headerSize = header.join('\n').length + 1
  const dataLines = lines.slice(2)

  for (const line of dataLines) {
    const lineSize = line.length + 1 // +1 for newline

    // If adding this line would exceed the limit
    if (currentSize + lineSize > maxChunkSize && currentChunk.length > 0) {
      // Save current chunk with header
      chunks.push([...header, ...currentChunk].join('\n'))
      currentChunk = []
      currentSize = 0
    }

    currentChunk.push(line)
    currentSize += lineSize
  }

  // Add remaining chunk
  if (currentChunk.length > 0) {
    chunks.push([...header, ...currentChunk].join('\n'))
  }

  // If no chunks were created (table is small), return the full table
  if (chunks.length === 0) {
    chunks.push(table)
  }

  return chunks
}












